var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_12446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2795 2.4707C10.5725 2.76367 10.5725 3.23945 10.2795 3.53242L4.27949 9.53242C3.98652 9.82539 3.51074 9.82539 3.21777 9.53242L0.217773 6.53242C-0.0751953 6.23945 -0.0751953 5.76367 0.217773 5.4707C0.510742 5.17773 0.986523 5.17773 1.27949 5.4707L3.7498 7.93867L9.22012 2.4707C9.51308 2.17773 9.98887 2.17773 10.2818 2.4707H10.2795Z",
    fill: "#2D65F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_12446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b1f81c06483c844ef8267140d0d0b7ae.svg";
export { ForwardRef as ReactComponent };